if (!customElements.get('ly-header-menu-mobile')) {
    customElements.define('ly-header-menu-mobile', class extends HTMLElement {

        connectedCallback() {
            this.hamburger = this.querySelector('.ly-header-menu-mobile-hamburger')
            this.hamburgerCheckbox = this.hamburger.querySelector('input')

            this.handleHumburgerChange()
            this.hamburger.addEventListener('change', this.handleHumburgerChange)
        }

        disconnectedCallback() {
            this.hamburger.removeEventListener('change', this.handleHumburgerChange)
        }

        handleHumburgerChange = () => {
            const checked = this.hamburgerCheckbox.checked
            this.hamburger.classList.toggle('is-checked', checked)
            document.documentElement.classList.toggle('is-header-menu-drawer-opened', checked)
        }

    })
}

class LyHeaderMenuMobileItemBase extends HTMLElement {
    connectedCallback() {
        this.moreTrigger = this.querySelector('.ly-header-menu-mobile-item-more')
        if (!this.moreTrigger) return
        this.moreTriggerCheckbox = this.moreTrigger.querySelector('input')

        this.handleChange()
        this.moreTrigger.addEventListener('change', this.handleChange)
    }

    disconnectedCallback() {
        this.moreTrigger.removeEventListener('change', this.handleChange)
    }

    handleChange = () => {
        const checked = this.moreTriggerCheckbox.checked

        if (checked) {
            this._onBeforeOpen?.()
        }

        requestAnimationFrame(() => {
            this.moreTrigger.classList.toggle('is-open', checked)
            this.classList.toggle('is-open', checked)
        })
    }

    _onBeforeOpen() { }
}

if (!customElements.get('ly-header-menu-mobile-item-lv1')) {
    customElements.define('ly-header-menu-mobile-item-lv1', class extends LyHeaderMenuMobileItemBase {

        initinalized = false

        connectedCallback() {
            super.connectedCallback()

            const script = this.querySelector('script[data-children]')
            if (script) {
                this.childrenData = readJsonFromScript(script)
            }
        }

        disconnectedCallback() {
            super.disconnectedCallback()
        }

        _onBeforeOpen = () => {
            if (this._childrenInited) return

            try {
                this._childrenInited = true
                this.initChildren()
            } catch (error) {
                this._childrenInited = false
            }
        }

        initChildren = () => {
            if (!this.childrenData || !this.childrenData.length) return

            // 创建 body
            const body = document.createElement('div')
            body.className = 'ly-header-menu-mobile-item-body lv_1 ly-expandable-grid'

            const inner = document.createElement('div')
            inner.className = 'ly-header-menu-mobile-item-body-inner lv_1 ly-expandable-grid-inner'

            body.appendChild(inner)

            // 插入到 header 后面
            const header = this.querySelector('.ly-header-menu-mobile-item-header.lv_1')
            header.insertAdjacentElement('afterend', body)

            // 渲染 lv2
            this.childrenData.forEach(lv2 => {
                inner.appendChild(this.createLv2(lv2))
            })
        }

        createLv2(lv2) {
            const el = document.createElement('ly-header-menu-mobile-item-lv2')
            el.childrenData = lv2.children
            el.className = 'ly-header-menu-mobile-item lv_2'

            let html = ''
            if (lv2.children?.length) {
                html = `
                <div class="ly-header-menu-mobile-item-link lv_2">
                    ${lv2.title}
                </div>
                <div class="ly-header-menu-mobile-item-more">
                    <input type="checkbox" class="ly-hide">
                    <span class="svg-wrapper">
                    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.8008 6.79981L6.80078 0.799804L0.800781 6.7998" stroke="#333333" stroke-opacity="0.6" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    </span>
                </div>
                `
            } else {
                html = `
                <a class="ly-header-menu-mobile-item-link lv_2" href="${lv2.link}">
                    ${lv2.title}
                </a>
                `
            }
            el.innerHTML = `
            <label class="ly-header-menu-mobile-item-header lv_2">
                ${html}
            </label>
            `
            return el
        }
    })
}

if (!customElements.get('ly-header-menu-mobile-item-lv2')) {
    customElements.define('ly-header-menu-mobile-item-lv2', class extends LyHeaderMenuMobileItemBase {
        _childrenInited = false

        connectedCallback() {
            super.connectedCallback()
        }

        disconnectedCallback() {
            super.disconnectedCallback()
        }

        _onBeforeOpen = () => {
            if (this._childrenInited) return

            try {
                this._childrenInited = true
                this.initChildren()
            } catch (e) {
                this._childrenInited = false
            }
        }

        initChildren = () => {
            if (!this.childrenData || !this.childrenData.length) return

            // 创建 body
            const body = document.createElement('div')
            body.className = 'ly-header-menu-mobile-item-body lv_2 ly-expandable-grid'

            const inner = document.createElement('div')
            inner.className = 'ly-header-menu-mobile-item-body-inner lv_2 ly-expandable-grid-inner'

            body.appendChild(inner)

            // 插入 header 后
            const header = this.querySelector('.ly-header-menu-mobile-item-header.lv_2')
            header.insertAdjacentElement('afterend', body)

            // 渲染 lv3
            const listStyle = this.childrenData.length > 6

            const wrapper = document.createElement('div')
            wrapper.className = 'ly-header-menu-mobile-item-content-wrapper lv_2'

            const innerWrapper = document.createElement('div')
            innerWrapper.className =
                `ly-header-menu-mobile-item-content-inner-wrapper lv_2 ly-hide-scrollbar ${listStyle ? 'list-style' : ''}`

            wrapper.appendChild(innerWrapper)
            inner.appendChild(wrapper)

            this.childrenData.forEach(item => {
                innerWrapper.appendChild(this.createLv3(item, listStyle))
            })
        }

        createLv3(item, listStyle) {
            const size = listStyle ? 90 : 178

            const a = document.createElement('a')
            a.className = 'ly-header-menu-mobile-item lv_3'
            a.href = item.link || '#'

            if (item.image) {
                const cover = document.createElement('div')
                cover.className = 'ly-header-menu-mobile-item-cover lv_3'

                const img = document.createElement('img')
                const baseUrl = item.image

                img.src = `${baseUrl}&width=${size}`
                img.srcset = `
                    ${baseUrl}&width=${size} 1x,
                    ${baseUrl}&width=${size * 2} 2x,
                    ${baseUrl}&width=${size * 3} 3x
                `
                img.width = size
                img.height = size
                img.loading = 'lazy'

                cover.appendChild(img)
                a.appendChild(cover)
            }

            const title = document.createElement('div')
            title.className = 'ly-header-menu-mobile-item-title lv_3'
            title.textContent = item.title

            a.appendChild(title)

            return a
        }
    })
}